import { isNumber } from './typeChecks';
export var isVisibleAndDisplayed = el => {
  var _window$getComputedSt;

  var isVisible = ((_window$getComputedSt = window.getComputedStyle(el)) === null || _window$getComputedSt === void 0 ? void 0 : _window$getComputedSt.visibility) === 'visible';
  var isDisplayed = Boolean(el === null || el === void 0 ? void 0 : el.getClientRects().length);
  return isVisible && isDisplayed;
};
export var isFocusable = el => {
  var {
    tagName
  } = el;

  if (tagName !== 'AREA' && !isVisibleAndDisplayed(el)) {
    return false;
  }

  if (['BUTTON', 'INPUT', 'SELECT', 'TEXTAREA'].includes(tagName)) {
    if (el.disabled) {
      return false;
    }

    if (el.closest('fieldset:disabled')) {
      return false;
    }

    return true;
  }

  if (tagName === 'A') {
    return el.hasAttribute('href');
  }

  var tabIndex = parseInt(el.getAttribute('tabindex'), 10);

  if (el.getAttribute('contenteditable') === 'true' || isNumber(tabIndex) && tabIndex > -1) {
    return true;
  }

  if (tagName === 'AREA' && el.hasAttribute('href')) {
    var map = el.closest('map');
    var img = map ? document.querySelector("img[usemap=\"#".concat(map.name, "\"]")) : null;
    return Boolean(map) && map.hasAttribute('name') && Boolean(img) && isVisibleAndDisplayed(img);
  }

  return false;
};
export var isTabbable = el => {
  if (el.tagName === 'INPUT' && el.type === 'radio') {
    var selected = document.querySelectorAll("[name=\"".concat(el.name, "\"]:checked"));

    if (selected && selected !== el) {
      return false;
    }
  }

  return el.tabIndex > -1 && isFocusable(el);
};
export var getTabbableDescendants = el => {
  var descendants = el.querySelectorAll('*');
  return Array.prototype.filter.call(descendants, isTabbable);
};
export var getTabOverrideElement = function getTabOverrideElement(e) {
  var {
    shiftKey: isShift,
    target
  } = e;

  for (var _len = arguments.length, restrictTabbingTo = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    restrictTabbingTo[_key - 1] = arguments[_key];
  }

  var tabbables = restrictTabbingTo.filter(el => el instanceof HTMLElement).map((el, index) => ({
    container: el,
    index,
    tabbableDescendants: getTabbableDescendants(el)
  })).filter(_ref => {
    var {
      tabbableDescendants
    } = _ref;
    return tabbableDescendants.length > 0;
  });
  var current = tabbables.find(_ref2 => {
    var {
      container
    } = _ref2;
    return container.contains(target);
  });

  if (!current) {
    return null;
  }

  if (isShift) {
    var [firstTabbableEl] = current.tabbableDescendants;

    if ([firstTabbableEl, current.container].includes(target)) {
      var previousIndex = tabbables[current.index - 1];
      var previous = previousIndex ? previousIndex : tabbables[tabbables.length - 1];
      return previous.tabbableDescendants[previous.tabbableDescendants.length - 1];
    }
  }

  if (!isShift) {
    var {
      tabbableDescendants
    } = current;
    var lastTabbableEl = tabbableDescendants[tabbableDescendants.length - 1];

    if (target === lastTabbableEl) {
      var nextIndex = tabbables[current.index + 1];
      var next = nextIndex ? nextIndex : tabbables[0];
      return next.tabbableDescendants[0];
    }
  }

  return null;
};